import React from 'react';
import { twJoin } from 'tailwind-merge';
import { ApiStatus } from '../../hooks/useApiStatusStore';
import { RelativeDate } from '../RelativeDate/RelativeDate';

const statusConfig: Record<ApiStatus, { text: string; statusColor: string }> = {
  CONNECTED: {
    text: 'Operational',
    statusColor: '#00BFAC',
  },
  RATE_LIMITED: {
    text: 'Rate Limited',
    statusColor: '#FDB00B',
  },
  DISCONNECTED: {
    text: 'Disconnected',
    statusColor: '#DE5E57',
  },
};

export const StatusIndicator: React.FC<{
  status: ApiStatus | undefined;
  rateLimitedUntil?: number;
}> = ({ status, rateLimitedUntil }) => {
  const { text, statusColor } = status
    ? statusConfig[status]
    : { text: '', statusColor: '#9CA3AF' };

  return (
    <div className="flex items-center gap-1">
      <div className="relative flex items-center justify-center">
        <div
          className="absolute size-3 rounded-full opacity-20"
          style={{
            backgroundColor: statusColor,
          }}
        />

        <div className="relative z-10 size-2.5 rounded-full">
          <div
            className={twJoin(
              'size-full rounded-full border border-neutral-800',
              !status ? 'animate-pulse' : ''
            )}
            style={{ backgroundColor: statusColor }}
          />
        </div>
      </div>

      {status && (
        <span className="text-xs leading-none text-contentSecondary">
          {text}
          {status === 'RATE_LIMITED' && rateLimitedUntil && rateLimitedUntil > Date.now() && (
            <span className="ml-2">
              (resets <RelativeDate timestamp={rateLimitedUntil} />)
            </span>
          )}
        </span>
      )}
    </div>
  );
};
